import { useFormFieldsLabels } from './fields-config/useFormFieldsLabels'
import { useFormFieldsNames } from './fields-config/useFormFieldsNames'
import { useFormFieldsValidations } from './fields-config/useFormFieldsValidations'

export const useFormFields = () => {
	const labels = useFormFieldsLabels()
	const names = useFormFieldsNames()
	const validations = useFormFieldsValidations()

	const fields = Object.keys(names).reduce((acc, nameKey) => {
		return {
			...acc,
			[nameKey]: {
				label: labels[nameKey],
				name: names[nameKey],
				validation: validations[names[nameKey]],
			},
		}
	}, {})

	return fields
}
